import React from "react";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import { Stack, Text } from "@bookingcom/bui-react";
import { BaggageItemDesktop } from "./BaggageItem.desktop.js";
export function BaggageSegmentDesktop(props) {
    const { flightSegment, baggageSegment, showHeader, hideIncludedSection } = props;
    return (React.createElement(Stack, { gap: 2 },
        showHeader ? React.createElement(BaggageSegmentHeaderDesktop, { flightSegment: flightSegment }) : undefined,
        React.createElement(BaggageSegmentListDesktop, { hideIncludedSection: hideIncludedSection, baggageSegment: baggageSegment })));
}
function BaggageSegmentHeaderDesktop(props) {
    const { flightSegment } = props;
    const i18n = useI18n();
    const { arrivalAirport } = flightSegment;
    return (React.createElement(Text, { tagName: "h4", variant: "emphasized_2" }, i18n.trans(t("flights_details_route", {
        variables: {
            city_name: arrivalAirport.cityName || arrivalAirport.name
        }
    }))));
}
function BaggageSegmentListDesktop(props) {
    const { baggageSegment, hideIncludedSection } = props;
    return baggageSegment.map((item, i) => {
        return (React.createElement(BaggageItemDesktop, { luggage: item, key: `${item.luggageType}-${i}`, hideIncludedSection: hideIncludedSection }));
    });
}
